import styled from "styled-components";

export const Styles = styled.div`
  width: 100%;

  .ant-select {
    width: 100%;
    .ant-select-selector {
    }
  }
`;
